// A6.21 — Eskalatsiya adapter. Module-local. Moderator qiyin shikoyatni yuqori
// tierга (senior|specialist|lead) eskalatsiya qiladi; escalated'lar alohida
// navbatда (junior navbatlaridan chiqariladi), senior hal qiladi yoki qaytaradi.
import { api } from '@/lib/api'

export const ESCALATION_LEVELS = ['senior', 'specialist', 'lead'] as const
export type EscalationLevel = (typeof ESCALATION_LEVELS)[number]

export interface EscalatedReport {
  id: number
  reporter_id?: number | null
  reporter_username?: string | null
  target_type: string
  target_id: number
  category: string
  reason?: string | null
  status: string
  created_at: number
  escalation_level?: string | null
  escalation_reason?: string | null
  escalated_by?: string | null // username
  escalated_at?: number
}

export async function escalateReport(id: number, level: EscalationLevel, reason: string): Promise<void> {
  await api.post(`/admin/reports/${id}/escalate`, { level, reason })
}

export async function deEscalateReport(id: number): Promise<void> {
  await api.post(`/admin/reports/${id}/de-escalate`, {})
}

export async function fetchEscalated(limit = 100): Promise<EscalatedReport[]> {
  const r = await api.get<{ items?: EscalatedReport[] }>('/admin/moderation/escalated', { query: { limit } })
  return r.items ?? []
}
